import { render } from "./home-solutions.vue?vue&type=template&id=f8c09568&scoped=true"
import script from "./home-solutions.vue?vue&type=script&lang=js"
export * from "./home-solutions.vue?vue&type=script&lang=js"

import "./home-solutions.vue?vue&type=style&index=0&id=f8c09568&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8c09568"]])

export default __exports__